import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "share",
  "use": "share-usage",
  "viewBox": "0 0 18 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 15\" id=\"share\"><path d=\"M11 4V0l7 7-7 7V9.9c-5 0-8.5 1.6-11 5.1C1 10 4 5 11 4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol